import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-check-empty-small",
  "use": "icon-check-empty-small-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol viewBox=\"0 0 24 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-check-empty-small\">\n<path d=\"M21.75 12.5C21.75 7.12 17.38 2.75 12 2.75C6.62 2.75 2.25 7.12 2.25 12.5C2.25 17.88 6.62 22.25 12 22.25C17.38 22.25 21.75 17.88 21.75 12.5ZM20.25 12.5C20.25 17.05 16.55 20.75 12 20.75C7.45 20.75 3.75 17.05 3.75 12.5C3.75 7.95 7.45 4.25 12 4.25C16.55 4.25 20.25 7.95 20.25 12.5Z\" fill=\"#CCCCCC\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol